import { Seeder } from '@mikro-orm/seeder';
import { EntityManager } from '@mikro-orm/mysql';
import { ProgramType } from '@/modules/user/entities/program-type.entity';
import { Program } from '@/modules/user/entities/program.entity';

function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export class ProgramTypesSeeder extends Seeder {
  async run(em: EntityManager): Promise<void> {
    // Programs should already be created by ProgramsSeeder
    const data: Record<string, string[]> = {
      'Four Year Highschool Program': [
        'Sports Student',
        'General Student',
        // 'General Readers',
        // 'Fons of Memoirs & life Stories',
      ],
      'Four Year Degree Program': ['College Student', 'Young Professional'],
      'Doctorate Program': ['Academics', 'Specialized Professional'],
    };

    for (const [programName, typeNames] of Object.entries(data)) {
      const program = await em.findOne(Program, { name: programName });
      if (!program) {
        // If program is missing for some reason, create it
        // (ideally ProgramsSeeder already created this)
        const created = em.create(Program, {
          name: programName,
          slug: slugify(programName),
          created_at: new Date(),
        });
        em.persist(created);
        await em.flush();
        // reload reference
        (program as unknown as Program) = created;
      }

      for (const name of typeNames) {
        let pt = await em.findOne(ProgramType, { name });
        if (!pt) {
          pt = em.create(ProgramType, {
            name,
            slug: slugify(name),
            program: program!,
            created_at: new Date(),
          });
          em.persist(pt);
        } else if (!pt.program) {
          pt.program = program!;
          em.persist(pt);
        }
      }
    }
  }
}
